import { render, staticRenderFns } from "./InvestReminderModal.vue?vue&type=template&id=b8140f56&scoped=true"
import script from "./InvestReminderModal.vue?vue&type=script&lang=ts"
export * from "./InvestReminderModal.vue?vue&type=script&lang=ts"
import style0 from "./InvestReminderModal.vue?vue&type=style&index=0&id=b8140f56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8140f56",
  null
  
)

export default component.exports